import { CheckCircle, XCircle } from "lucide-react";
import { useState, useEffect } from "react";

export default function CreateWorkflowModal({
  isOpen,
  onClose,
  onCreate,
  status
}) {
  const [form, setForm] = useState({
    name: "",
    description: "",
    triggerType: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    if (status === "success") {
      setForm({ name: "", description: "", triggerType: "" });
      setError("");
    }
  }, [status]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.name || !form.description || !form.triggerType) {
      setError("All fields are required");
      return;
    }

    setError("");
    onCreate(form);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-6">
        <h2 className="text-lg font-semibold mb-4">Create New Workflow</h2>

        {error && (
          <div className="mb-3 text-sm text-red-600 bg-red-50 p-2 rounded">
            {error}
          </div>
        )}

        <div className="space-y-4">
          <input
            name="name"
            placeholder="Workflow name"
            className="w-full border rounded px-3 py-2 text-sm"
            value={form.name}
            onChange={handleChange}
          />

          <textarea
            name="description"
            placeholder="Workflow description"
            rows={3}
            className="w-full border rounded px-3 py-2 text-sm"
            value={form.description}
            onChange={handleChange}
          />

          <select
            name="triggerType"
            className="w-full border rounded px-3 py-2 text-sm"
            value={form.triggerType}
            onChange={handleChange}
          >
            <option value="">Select trigger</option>
            <option value="webhook_event">Webhook</option>
            {/* <option value="scheduled">Schedule</option>
            <option value="manual">Manual</option> */}
          </select>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm bg-gray-100 rounded hover:bg-gray-200"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={status === "loading"}
            className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-60"
          >
            {status === "loading" ? "Creating..." : "Create Workflow"}
          </button>
        </div>

        {status === "success" && (
          <div className="flex items-center justify-center gap-2 text-green-600 mt-4 animate-pulse">
            <CheckCircle size={20} />
            <span className="text-sm">Workflow created</span>
          </div>
        )}

        {status === "error" && (
          <div className="flex items-center justify-center gap-2 text-red-600 mt-4">
            <XCircle size={20} />
            <span className="text-sm">Failed to create workflow</span>
          </div>
        )}
      </div>
    </div>
  );
}
